import {Component, OnDestroy, OnInit} from "@angular/core";
import {exposeComponentInDebugMode} from "../misc/expose-component-in-debug-mode.decorator";
import {workflowStepInformation, WorkflowStepStatus} from "./models/workflow-step-status.enum";
import {WorkflowService} from "./workflow.service";
import {handleErrors} from "../misc/handle-errors.decorator";
import {Subscription} from "rxjs/Subscription";

@Component({
  selector: "workflow-status-change",
  templateUrl: "./workflow-status-change.template.pug",
})
@exposeComponentInDebugMode({multi: true})
export class WorkflowStatusChangeComponent implements OnInit, OnDestroy {
  private subscription: Subscription;
  allowedTransitions: {value: WorkflowStepStatus, name: string}[] = [];
  text: string = "";
  editing: boolean = false;

  private calculateAllowedTransitions(status: WorkflowStepStatus) {
    if (!status || !workflowStepInformation[status]) return;
    this.text = workflowStepInformation[status].name || "unknown";
    this.allowedTransitions = workflowStepInformation[status].allowedStateTransitions
      .map(value => ({value, name: workflowStepInformation[value].name}));
  }

  startEditing() {
    this.editing = true;
  }

  @handleErrors()
  async switchState(newState) {
    await this.workflowService.setStepStatus(newState);
    this.editing = false;
  }

  ngOnInit() {
    this.subscription = this.workflowService.workflowStepStatus.subscribe((status) => {
      this.calculateAllowedTransitions(status);
    });
  }

  ngOnDestroy() {
    if (this.subscription && !this.subscription.closed) this.subscription.unsubscribe();
  }

  constructor(public workflowService: WorkflowService) {}
}
